module.exports = __webpack_public_path__ + "static/media/slide7.41e7cedf.gif";